export enum UserType {
  /** 正式在职账号 */
  FORMAL = "FORMAL",
  /** 虚拟账号 */
  VIRTUAL = "VIRTUAL",
  /** 外部人员账号 */
  EXTERNAL = "EXTERNAL",
  /** 公有账号 */
  PUBLIC = "PUBLIC",
  /** 离职账号 */
  QUIT = "QUIT",
  /** 未知账号类型 */
  UN_KNOWN = "UN_KNOWN"
}
export interface UserTeamInfoInterface {
  teamInfoList: TeamUserInfo[];
  joinTeamRecordList: ApplyRecordInterface[];
}
export interface ApplyRecordInterface {
  teamId: string;
  teamFullName: string;
  logoUrl: string;
  approveStatus: 1 | 2 | 3;
}
export interface CreateTeamAndEmployee {
  account: string;
  ddAppId: string;
  mobile: string;
  realName: string;
  teamFullName: string;
  teamId: string;
  teamShortName: string;
  headImg: string;
  userType?: UserType;
}
export interface TeamUserInfo {
  emplEnabled?: string;
  account: string;
  ddAppId: string;
  headImg: string | null;
  displayDeptName?: string;
  mobile: string;
  realName: string;
  teamFullName: string;
  teamId: string;
  teamShortName: string;
  email?: string;
  hasBindEmail?: boolean;
  hasBindMobile?: boolean;
  hasPassword?: boolean;
  userType?: UserType;
}

export interface ApprovaTeamUserInfo {
  account: string;
  ddAppId: string;
  mobile: string;
  realName: string;
  teamFullName: string;
  teamId: string;
  teamShortName: string;
  approveStatus: approveStatusEnum;
}

export enum approveStatusEnum {
  NO_PASS = 3,
  WAIT = 1,
  PASS = 2
}

export type ApprovaTeamUserInfoList = ApprovaTeamUserInfo[];

export interface SendJoinApproveRes {
  // isApprove: boolean;
  needApprove: boolean;
  // joinResult: string;
}
export interface InviteUserInfo {
  teamId: string;
  teamName: string;
  userName: string;
  userId: string;
  avatar: string;
  inviteCode: string;
}

export interface PublicUserInfo {
  currentUser: string | null;
  headImg: string | null;
  realName: string;
  teamFullName: string;
  teamId: string;
  teamShortName: string;
  userId: string;
}

export interface PublicAccountListRes {
  publicAccountList: PublicUserInfo[] | null;
}

export interface AuthDataRes {
  loginStatus: "NORMAL" | "NEW_USER" | "NEW_TEAM" | "SELECT_ACCOUNT";
  refreshToken: string;
  refreshTokenExpireIn: number;
  accessToken: string;
  accessTokenExpireIn: number;
  account: string;
  ddAppId: string;
  headImg: string | null;
  station: string;
  nickName: string | null;

  /**
   * @deprecated 这个字段在切换用户或者修改用户名之后，有可能还是上一次登录的用户名，不推荐用
   */
  realName: string | null;
  userId: string;
  selectedTeamId: string;
  teamUserInfo: TeamUserInfo;
  teamUserInfoList: TeamUserInfo[];
  mobile?: string;
  email?: string;
  hasPassword?: boolean;
  hasBindMobile?: boolean;
  hasBindEmail?: boolean;
  publicUserInfo: PublicUserInfo;
  publicAccountList: PublicUserInfo[] | null;
  ticket: string | null;
  loginType?: string;
}
export interface TeamLoginTypeInfo {
  type: string;
  typeName: string;
}
export interface TeamLoginTypeRes {
  teamId: string;
  typeList: TeamLoginTypeInfo[];
}
export interface ValidateAccountRes {
  hasPassword: boolean;
  isTrustedDevice: boolean;
  hasMobile: boolean;
  hasIdNum: boolean;
  hasEmail: boolean;
}

export enum BizTypeEnum {
  APP_LOGIN = "APP_LOGIN",
  SET_PASSWORD = "SET_PASSWORD",
  BIND_MOBILE = "BIND_MOBILE",
  BIND_EMAIL = "BIND_EMAIL",
  UPDATE_BIND_MOBILE = "UPDATE_BIND_MOBILE",
  UPDATE_BIND_EMAIL = "UPDATE_BIND_EMAIL",
  SELECT_ACCOUNT = "SELECT_ACCOUNT"
}
export interface ValidateAccountReq {
  bizType: BizTypeEnum;
  loginName: string;
  loginNameType: string;
  teamId?: string;
  registerFlag?: number;
}
export interface CaServerSecurityRes {
  strServerCert: string;
  strServerRan: string;
  strSignedData: string;
}

// -1: 未申请, 0:待审核, 1:审核通过, 2:审核驳回
export enum ApplySatus {
  NOT_APPLY = -1,
  APPLYING = 0,
  APPROVE = 1,
  REJECT = 2
}

export interface EnableApprStatusRes {
  manageFullDeptName: string;
  apprStatus: ApplySatus;
  apprOption: string; // 审核意见
  manageUserId: string;
  manageHeadImg: string;
  manageTeamId: string;
  manageRealName: string;
}
